import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const StylistList = () => {

  return (
    <Table tableId="stylists" title="Stylist" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="full_name" idKey="stylist_id" fieldsToSearch={["Name", "Email", "Phone"]} />
  );
};

export default StylistList;